/** Smallest online top-up; mirrors PORTAL_TOPUP_MIN_SOM in the API's portal billing. */
export const PORTAL_TOPUP_MIN_SOM = 1_000;

export interface TestPaymentBreakdown {
  priceSom: number;
  /** Part of the price the learner's balance covers. */
  fromBalanceSom: number;
  /**
   * What the learner pays in: the shortfall, raised to PORTAL_TOPUP_MIN_SOM. 0 means the balance
   * covers the test.
   */
  dueSom: number;
  /** Balance left after the top-up and the purchase. */
  balanceAfterSom: number;
}

/**
 * Splits a paid test's price into what the balance covers and what is still due.
 * Display only: the server re-checks the balance and debits the full price.
 */
export function calculateTestPayment(priceSom: number, balanceSom: number): TestPaymentBreakdown {
  const price = Math.max(0, priceSom);
  const balance = Math.max(0, balanceSom);
  const fromBalanceSom = Math.min(balance, price);
  const shortfall = price - fromBalanceSom;
  const dueSom = shortfall > 0 ? Math.max(shortfall, PORTAL_TOPUP_MIN_SOM) : 0;
  return {
    priceSom: price,
    fromBalanceSom,
    dueSom,
    balanceAfterSom: balance + dueSom - price,
  };
}
